import { gql } from 'graphql-request';

/**
 * Query to fetch the current viewer's enabled features.
 * Called on authentication to load feature flags into context.
 */
export const VIEWER_FEATURES_QUERY = gql`
  query ViewerFeatures {
    viewer {
      id
      userId
      email
      features
      role
      isAdmin
    }
  }
`;

export interface ViewerFeaturesData {
  viewer: {
    id: string;
    userId: string;
    email: string;
    features: string[];
    role: string;
    isAdmin: boolean;
  } | null;
}
